<template>
  <div class="mt-[24px]">
    <img
      src="assets/images/my-giving/building-fund/TithingComitment_HOGCAPP.png"
      alt="Building Fund"
      class="w-[128px] h-[88px] md:w-[160px] md:h-[110px] lg:w-[192px] lg:h-[132px]"
    />
    <p
      class="font-[900] text-gray-800 mt-[16px] md:mt-[20px] lg:mt-[24px] text-[1.75rem] md:text-[2.25rem] lg:text-[2.5rem] tracking-tighter"
    >
      My Tithing History
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
